<div class="container-grid" [ngStyle]="containerStyles">
	<div>
    <label for="fechaRecinto" class="form-label">Fecha de ingreso de mercancía</label>
    <input
      type="date"
      id="fechaRecinto"
      class="form-control"
      [value]="entry.admission_date | slice:0:10"
			disabled
    />
  </div>
	<div>
    <label for="tonelaje" class="form-label">Tonelaje traspasado</label>
    <input
      type="text"
      id="tonelaje"
      class="form-control"
      [value]="entry.total_weight"
			disabled
    />
  </div>
	<div>
    <label for="pieces" class="form-label">Piezas traspasadas</label>
    <input
      type="text"
      id="pieces"
      class="form-control"
      [value]="entry.total_pieces"
			disabled
    />
  </div>
	<div class="grid-first">
    <label for="lote" class="form-label">Lote de origen del material</label>
    <input
      type="text"
      id="lote"
      class="form-control"
      [value]="entry.cabotage_batch_transfered"
			disabled
    />
  </div>
	<div class="grid-span2">
    <label for="observations" class="form-label">Observaciones</label>
    <input
      type="text"
      id="observations"
      class="form-control"
      [value]="entry.observations"
			disabled
    />
  </div>
	<div class="grid-first">
    <label for="person" class="form-label">Persona que realizó el traspaso de material</label>
    <input
      type="text"
      id="person"
      class="form-control"
      [value]="entry.transfered_by"
			disabled
    />
  </div>
	<div>
    <label for="output" class="form-label">Salida a la que pertenece esta entrada de transferencia</label>
    <input
      type="text"
      id="output"
      class="form-control"
      [value]="entry.output_id"
			disabled
    />
  </div>
	<div class="grid-all container-button">
    <button
      type="button"
      class="btn-lote me-5"
      (click)="regresar()"
    >
      Regresar
    </button>
  </div>
</div>